import { css } from "@emotion/react"
import React from "react"
import { Card } from "react-bootstrap"

const componentStyles = css`
    width: 100%;
    max-width: 25rem;

    .card-header {
        color: #002345;
        font-weight: bold;
        border-bottom: none;
        background-color: #fff;
    }

    .custom-card {
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        overflow: hidden;
        transition: transform 0.2s ease-in-out;
        margin-bottom: 20px;
    }

    .custom-card:hover {
        transform: scale(1.02);
    }

    .custom-card-body {
        padding: 1rem;
    }

    .custom-text {
        font-size: 1rem;
        line-height: 1.3;
        margin-bottom: 1rem;
        color: #333;
        cursor: pointer;
    }

    .notification-date {
        font-size: 0.85rem;
        color: #777;
        margin-right: 0.5rem;
        max-width: 50px;
        line-height: 1.3;
        margin-bottom: 1rem;
    }

    .centered-item {
        padding-top: 60px;
    }
`

const NotificationsCard = ({ data }) => {
    const formatDateToNewYorkTime = (dateString) => {
        if (!dateString) return ""

        const options = {
            timeZone: "America/New_York",
            year: "2-digit",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        }
        const date = new Date(dateString)
        const localeString = date.toLocaleString("en-US", options)

        const [datePart, timePart] = localeString.split(", ")
        const [time, period] = timePart.split(" ")

        return `${datePart} ${time}${period}`
    }

    return (
        <div css={componentStyles}>
            <Card className="w-100 custom-card">
                <Card.Header className="text-center card-header">Notifications</Card.Header>
                <Card.Body className="custom-card-body">
                    {data?.map((item) => (
                        <div
                            key={item.id}
                            className="d-flex align-items-center">
                            <span className="notification-date">{formatDateToNewYorkTime(item.createdUtc)}</span>
                            <span className="custom-text">{item.message}</span>
                        </div>
                    ))}
                    {(!data || data?.length === 0) && (
                        <span className="text-center h5 centered-item">Notifications not Available</span>
                    )}
                </Card.Body>
            </Card>
        </div>
    )
}

export default NotificationsCard
